import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { useAgentsAdminContext } from "../providers/agents-admin.provider";

interface IPrivateRoutes {
  children: ReactNode;
}

const PrivateAdminRoute = (props: IPrivateRoutes) => {
  const { children } = props;
  const { isLogin } = useLoginUser();
  const { sponsor } = useAgentsAdminContext();
  if (!isLogin) {
    return <Navigate to={`/${sponsor}/admin/`} />;
  }
  return <>{children}</>;
};

export default PrivateAdminRoute;
